import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FC } from 'react';

type SunProps = {
    className?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Sun: FC<SunProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'sun'}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            viewBox="0 0 20 20"
            fill="none"
        >
            <path d="M10 5.14a4.86 4.86 0 100 9.72 4.86 4.86 0 000-9.72zm0 9a4.14 4.14 0 110-8.28 4.14 4.14 0 010 8.28z" />
            <path d="M10.36 0h-.72v3.56h.72V0z" />
            <path d="M10.36 16.44h-.72V20h.72v-3.56z" />
            <path d="M20 9.64h-3.56v.72H20v-.72z" />
            <path d="M3.56 9.64H0v.72h3.56v-.72z" />
            <path d="M16.817 2.673L14.299 5.19l.51.51 2.517-2.518-.51-.509z" />
            <path d="M5.191 14.301l-2.517 2.517.509.51L5.7 14.81l-.509-.509z" />
            <path d="M14.808 14.299l-.509.51 2.518 2.516.509-.509-2.518-2.517z" />
            <path d="M3.183 2.674l-.51.51L5.192 5.7l.51-.509-2.518-2.517z" />
        </svg>
    );
};

export default Sun;
